module.exports = __webpack_public_path__ + "img/apply-for-rent-2-en.0b3d095.png";